// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"970e923b","732":"9b258ad4","977":"7daa7f31"}[chunkId] + ".chunk.js";
};